import { createFileRoute } from '@tanstack/react-router';
import { AdminAddressesPage } from '@/features/admin/admin-addresses-page';

export const Route = createFileRoute('/admin/addresses/')({
  component: AdminAddressesIndexRoute,
});

function AdminAddressesIndexRoute() {
  return <AdminAddressesPage />;
}
